function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlephium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 562 952",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M187.296 627.61c0-12.338-9.715-20.641-21.68-18.532L21.68 634.454C9.715 636.564 0 648.293 0 660.63v271.855c0 12.337 9.715 20.641 21.68 18.531l143.936-25.376c11.965-2.109 21.68-13.838 21.68-26.176V627.61Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.888 18.859c0-12.337-9.715-20.641-21.681-18.532L396.272 25.704c-11.966 2.109-21.68 13.838-21.68 26.176v271.854c0 12.338 9.714 20.641 21.68 18.532l143.935-25.376c11.966-2.11 21.681-13.839 21.681-26.176V18.859Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.6,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.743 82.363c-5.557-12.239-20.477-20.34-33.297-18.08L23.229 91.472c-12.821 2.26-18.717 14.031-13.16 26.27l341.076 751.207c5.557 12.239 20.477 20.341 33.297 18.08l154.217-27.188c12.82-2.26 18.717-14.032 13.16-26.271L210.743 82.363Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlephium);
export default __webpack_public_path__ + "static/media/alephium.016ce344ce634a84a1c31529080cda74.svg";
export { ForwardRef as ReactComponent };